import axios from 'axios';
// const hubchatUrl = 'https://chathub.allchat.fpt.vn/';
// const hubchatUrl = 'http://42.116.254.246:3000/';
// const hubchatUrl = 'http://42.116.254.246:3000/';
// const hubchatUrl = 'http://42.116.255.194:3000/';
// const hubchatUrl = 'http://172.30.13.180:3000/';
const hubchatUrl = 'https://chathub.allchat.fpt.vn/';

class Chathub {
    initToken(length = 30) 
    {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        this.token = result;
        return result;
    }

    setToken(token = null)
    {
        if(token == null) {
            this.initToken();
        } else {
            this.token = token;
        }
        return  axios({
            method: 'get',
            url: hubchatUrl + 'api/v1/livechat/config?token=' + this.token,
        });
          
    }

    registerUser(name, email)
    {
        var token   = this.token;
        var resultRegister = null;
        resultRegister = axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/visitor',
            data: {
                visitor: {
                    name : name,
                    email : email,
                    token : token
                }
            }
        }).then( function (response) {
            var that = new Chathub;
            let result = that.createRoomchat(token);
            result = result.then(response => response).catch(function (error) {
                return {success : false};
            });
            return result;
        });

        return resultRegister;
          
    }

    registerUserOffline(name, email)
    {
        var token   = this.token;
        var resultRegister = null;
        resultRegister = axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/visitor',
            data: {
                visitor: {
                    name : name,
                    email : email,
                    token : token
                }
            }
        })

        return resultRegister;
          
    }

    createRoomchat(token = null)
    {
        var resultRoomchat = null;

        if (token == null) {
            token = this.token;
        }

        resultRoomchat = axios({
            method: 'get',
            url: hubchatUrl + 'api/v1/livechat/room?token='+token,
        })
        .then (response => response.data);

        return resultRoomchat;

    }

    sendMessage(token, room, msg)
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/message',
            data: {
                msg : msg,
                rid : room,
                token : token
            }
        })

    }

    getHistoryMessage(token, room) {
        return axios({
            method: 'get',
            url: hubchatUrl + 'api/v1/livechat/messages.history/' + room + '?token=' + token + '&limit=30',
        })
    }

    changeName(token, name)
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/custom.fields',
            data: {
                token : token,
                customFields : [{
                    key : 'other_name',
                    value : name,
                    overwrite : true
                }],
              
            }
        })

    }

    leaveRoom(roomId, token) 
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/room.close',
            data: {
                rid : roomId,
                token : token
            }
        })
    }

    setGender(token, gender)
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/custom.fields',
            data: {
                token : token,
                customFields : [{
                    key : 'gender',
                    value : gender,
                    overwrite : true
                }],
            }
        })

    }

    setContract(token, contract)
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/custom.fields',
            data: {
                token : token,
                customFields : [{
                    key : 'contract',
                    value : contract,
                    overwrite : true
                }],
            }
        })

    }

    checkAgent(token)
    {
        return axios({
            method: 'get',
            url: hubchatUrl + 'api/v1/livechat/agent.next/' + token,
            
        })
    }


    sendOfflineMessage(name, email, message)
    {
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/offline.message',
            data: {
                name : name,
                email : email,
                message : message
            }
        })
    }

    uploadFile(file, roomid, token)
    {
        var form = new FormData();
        form.append('file',file);
 
        return axios({
            method: 'post',
            url: hubchatUrl + 'api/v1/livechat/upload/' + roomid,
            data : form,
            headers: {
                'x-visitor-token' : token,
            }
        })
    }

    getImageFile(id, name)
    {
        return hubchatUrl + "file-upload/"+id+"/"+name
    }

    getRootUrl()
    {
        return hubchatUrl;
    }

    getAgentInfo(room, token)
    {
        return axios({
            method: 'get',
            url: hubchatUrl + 'api/v1/livechat/agent.info/' + room + '/' + token,
            
        })
    }


}

export default Chathub
